import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { some } from "../Docs/fable_modules/fable-library.3.7.1/Option.js";

export class Column {
    constructor() {
    }
}

export function Column$reflection() {
    return class_type("Feliz.TanStack.Table.Filter.Column", void 0, Column);
}

export function Column_getCanFilter_Z2685F962(column) {
    return column.getCanFilter();
}

export function Column_getFilterValue_Z2685F962(column) {
    const filterValue = column.getFilterValue();
    if (filterValue == null) {
        return void 0;
    }
    else {
        return some(filterValue);
    }
}

export function Column_setFilterValue(value, column) {
    column.setFilterValue((x) => ((x == null) ? value(void 0) : value(some(x))));
    return column;
}

export function Column_getCanGlobalFilter_Z2685F962(column) {
    return column.getCanGlobalFilter();
}

export function Column_getFilterIndex_Z2685F962(column) {
    return column.getFilterIndex();
}

export function Column_getIsFiltered_Z2685F962(column) {
    return column.getIsFiltered();
}

export class Row {
    constructor() {
    }
}

export function Row$reflection() {
    return class_type("Feliz.TanStack.Table.Filter.Row", void 0, Row);
}

export function Row_columnFilters_773C3262(row) {
    return row.columnFilters;
}

export function Row_columnFiltersMeta_773C3262(row) {
    return row.columnFiltersMeta;
}

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Filter.Table", void 0, Table);
}

export function Table_filterFns_Z4395D14A(table) {
    return table.filterFns;
}

export function Table_filterFromLeafRows_Z4395D14A(table) {
    return table.filterFromLeafRows;
}

//# sourceMappingURL=Filter.fs.js.map
